import { render, staticRenderFns } from "./patient-classification.vue?vue&type=template&id=251598a7&scoped=true&lang=pug&"
import script from "./patient-classification.vue?vue&type=script&lang=ts&"
export * from "./patient-classification.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251598a7",
  null
  
)

export default component.exports